<template>
  <v-container fluid style="height: 100%;" class="pl-0 pr-0 py-0 m-0 box" align-stretch>
    <v-layout row wrap ma-0 py-4 justify-start>
      <v-flex :class="[$vuetify.breakpoint.lgAndUp ? 'col-6' : 'col-12']">
        <p class="font-weight-medium my-0 ml-4">มูลเหตุสันนิษฐาน (ครั้ง)</p>
        <v-card
          class="d-flex justify-space-around my-2 pl-4"
          :class="[{ row: $vuetify.breakpoint.smAndDown }]"
          flat
        >
          <v-card
            v-for="(item, i) in causes"
            class="rectangle1  px-0 pt-0"
            :key="i"
            :v-show="item.accident > 0"
            :class="[
              { 'col': $vuetify.breakpoint.lgAndUp },
              { 'col': $vuetify.breakpoint.mdOnly },
              { 'ml-3': i != 0 && $vuetify.breakpoint.mdAndUp },
              { 'col-12 mx-2 mb-4': $vuetify.breakpoint.smAndDown }
            ]"
          >
            <div>
              <p class="subtitle-2 text-center mt-3 mb-2 title-cause">{{ item.name }}</p>
            </div>
            <div class="pa-0 px-2">
              <v-layout ma-0>
                <v-flex xs5>
                  <v-img
                    class="sub-menu"
                    height="32"
                    width="32"
                    :src="getCauseImage(item.id)"
                  ></v-img>
                </v-flex>
                <v-flex xs7 text-center>
                  <p class="font-weight-medium my-0 title number">
                    {{ item.accident | numFormat }}
                  </p>
                  <p class="caption mb-0">{{ item.percentage }}</p>
                </v-flex>
              </v-layout>
            </div>
            <v-row class="ma-0 pt-6 text-center cause-casualty">
              <v-col cols="6" class="pa-0">
                <div class="text-center">
                  <v-img
                    contain
                    height="28"
                    :src="require('@/assets/icons/death.svg')"
                    class="ma-0 mt-2"
                  ></v-img>
                  <!-- <i :class="`fas fa-dizzy fa-2x`" class="ma-0 mt-2"></i> -->
                </div>
                <p class="font-weight-medium subtitle-1 my-0">{{ item.dead | numFormat }}</p>
                <p class="subtitle-2 my-0">คน</p>
              </v-col>
              <v-col cols="6" class="pa-0">
                <div class="text-center">
                  <v-img
                    contain
                    height="28"
                    :src="require('@/assets/icons/user-injured-solid.svg')"
                    class="ma-0 mt-2"
                  ></v-img>
                </div>
                <p class="font-weight-medium subtitle-1 my-0">{{ item.injury | numFormat }}</p>
                <p class="subtitle-2 my-0">คน</p>
              </v-col>
            </v-row>
          </v-card>
        </v-card>
      </v-flex>
      <!-- <v-flex class="col-1"></v-flex> -->
      <v-flex :class="[$vuetify.breakpoint.lgAndUp ? 'col-6' : 'col-12']">
        <p class="font-weight-medium my-0 ml-4">ลักษณะการเกิดอุบัติเหตุ (ครั้ง)</p>
        <v-card
          class="d-flex justify-space-around my-2 pl-4"
          :class="[{ row: $vuetify.breakpoint.smAndDown }]"
          flat
        >
          <v-card
            class="rectangle1 px-0 pt-0"
            v-for="(item, i) in characters"
            :key="i"
            :v-show="item.accident > 0"
            :class="[
              { 'col': $vuetify.breakpoint.lgAndUp },
              { 'col': $vuetify.breakpoint.mdOnly },
              { 'ml-3': i != 0 && $vuetify.breakpoint.mdAndUp },
              { 'col-12 mx-2 mb-4': $vuetify.breakpoint.smAndDown }
            ]"
          >
            <div>
              <p class="subtitle-2 text-center mt-3 mb-2 title-cause">{{ item.name }}</p>
            </div>
            <div class="pa-0 px-2">
              <v-layout ma-0>
                <v-flex xs5>
                  <v-img
                    class="sub-menu"
                    height="32"
                    width="32"
                    :src="getCharacterImage(item.id)"
                  ></v-img>
                </v-flex>
                <v-flex xs7 text-center>
                  <p class="font-weight-medium my-0 title number">
                    {{ item.accident | numFormat }}
                  </p>
                  <p class="caption mb-0">{{ item.percentage }}</p>
                </v-flex>
              </v-layout>
            </div>
            <v-row class="ma-0 pt-6 text-center cause-casualty">
              <v-col cols="6" class="pa-0">
                <div class="text-center">
                  <v-img
                    contain
                    height="28"
                    :src="require('@/assets/icons/death.svg')"
                    class="ma-0 mt-2"
                  ></v-img>
                  <!-- <i :class="`fas fa-dizzy fa-2x`" class="ma-0 mt-2"></i> -->
                </div>
                <p class="font-weight-medium subtitle-1 my-0">{{ item.dead | numFormat }}</p>
                <p class="subtitle-2 my-0">คน</p>
              </v-col>
              <v-col cols="6" class="pa-0">
                <div class="text-center">
                  <v-img
                    contain
                    height="28"
                    :src="require('@/assets/icons/user-injured-solid.svg')"
                    class="ma-0 mt-2"
                  ></v-img>
                </div>
                <p class="font-weight-medium subtitle-1 my-0">{{ item.injury | numFormat }}</p>
                <p class="subtitle-2 my-0">คน</p>
              </v-col>
            </v-row>
          </v-card>
        </v-card>
      </v-flex>
    </v-layout>

    <v-layout row wrap ma-0 pb-4 justify-start>
      <v-flex xs12>
        <p class="font-weight-medium my-0 ml-4 pl-4">ยานพาหนะที่เกิดเหตุ (คัน)</p>
        <v-card
          class="d-flex justify-start ma-0 my-2 px-2"
          :class="[{ row: $vuetify.breakpoint.smAndDown }, { 'pl-4': $vuetify.breakpoint.mdAndUp }]"
          flat
        >
          <v-flex class="col-3" v-if="$vuetify.breakpoint.mdAndUp"></v-flex>
          <v-flex :class="[$vuetify.breakpoint.mdAndUp ? 'col-6' : 'col-12']" ref="chartContainer">
            <v-card class="rectangle2 ml-0">
              <highcharts class="charts-pie" :options="chartPieOptions" ref="chart"></highcharts>
            </v-card>
          </v-flex>
        </v-card>
        <v-card
          class="d-flex justify-center ma-0 my-2 px-2"
          :class="[{ row: $vuetify.breakpoint.smAndDown }, { 'pl-4': $vuetify.breakpoint.mdAndUp }]"
          flat
        >
          <v-flex
            v-for="(item, i) in vehicles"
            :key="i"
            :class="[
              { 'col-3': $vuetify.breakpoint.mdAndUp },
              { 'col-12 mb-4': $vuetify.breakpoint.smAndDown }
            ]"
          >
            <v-card class="rectangle2">
              <v-layout>
                <v-flex xs6>
                  <div>
                    <p class="subtitle-2 text-center mt-3 mb-2 title-cause">{{ item.name }}</p>
                  </div>
                  <div class="pa-0 pt-4">
                    <v-layout ma-0 pl-2>
                      <v-flex xs5>
                        <v-img
                          class="sub-menu"
                          height="32"
                          width="32"
                          :src="getVehicleImage(item.id)"
                        ></v-img>
                      </v-flex>
                      <v-flex xs7 pl-2>
                        <p class="font-weight-medium my-0 title number">
                          {{ item.accident | numFormat }}
                        </p>
                        <p class="subtitle-2 mb-0">{{ item.percentage }}</p>
                      </v-flex>
                    </v-layout>
                  </div>
                  <div>
                    <p class="subtitle-2 text-center mt-3 mb-0">จำนวนอุบัติเหตุ</p>
                    <p class="font-weight-medium subtitle-1 text-center my-2">
                      {{ item.accident_count | numFormat }} ครั้ง
                    </p>
                    <p class="subtitle-2 text-center my-0">คิดเป็น {{ summary ? (item.accident_count / summary.accident.summary * 100).toFixed(2) : '-' }}%</p>
                  </div>
                </v-flex>
                <v-flex xs6 px-2>
                  <p class="subtitle-2 mt-3 mb-2 number">สาเหตุ 3 อันดับสูงสุด</p>
                  <v-flex v-for="(cause, i) in item.cause" :key="i">
                    <p class="font-weight-medium caption mt-2 mb-0">{{ cause.name }}</p>
                    <p class="font-weight-medium caption mb-2">
                      {{ cause.amount | numFormat }} คัน
                    </p>
                  </v-flex>
                  <v-flex v-show="item.cause.length == 0">
                    <p class="font-weight-medium caption mt-2 mb-0">ไม่พบข้อมูล</p>
                  </v-flex>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'Cause',
  props: {
    searchCondition: {
      type: Object
    },
    summary: {
      type: Object
    }
  },
  data: () => ({
    title: 'มูลเหตุสันนิฐาน',
    chartPieOptions: null,
    colors: ['#f3a055', '#758f39', '#4f3f40', '#B57B0D'],
    causes: [],
    characters: [],
    vehicles: []
  }),
  created() {
    this.initData();
    this.getChartOptions();
    const scope = this;
    window.resizeVehicleTimeOut = () => {
      if (window.resizeVehicleChart) {
        clearTimeout(window.resizeVehicleChart);
      }
      window.resizeVehicleChart = setTimeout(() => {
        // scope.chartPieOptions.chart.width = scope.$refs.chartContainer.clientWidth;
        scope.$refs.chart.chart.reflow();
      }, 500);
    };
    window.addEventListener("resize", window.resizeVehicleTimeOut);
  },
  mounted() {
  },
  destroyed() {
    window.removeEventListener("resize", window.resizeVehicleTimeOut);
  },
  computed: {},
  methods: {
    init() {
      this.search();
    },
    getChartOptions() {
      const scope = this;
      this.chartPieOptions = {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie',
          height: 300,
          style: {
            fontFamily: 'Kanit'
          }
        },
        title: {
          text: null
        },
        subtitle: {
            text: '',
            align: 'right',
            x: -10
        },
        xAxis: {
          crosshair: true
        },
        yAxis: {
          title: null
        },
        legend: {
          align: 'center',
          verticalAlign: 'bottom',
          x: 0,
          y: -20
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              formatter: function() {
                return this.y ? this.y.toFixed(0) + ' คัน' : '';
              },
              distance: 0
            },
            showInLegend: true
          }
        },
        tooltip: {
          headerFormat: '<span style="font-size:11px">จำนวนยานพาหนะ</span><br/>',
          pointFormat: '{point.name}: <b>{point.y:,.0f} คัน</b>'
        },
        colors: null,
        series: {
          data: []
        },
        lang: {
            noData: 'ไม่พบข้อมูล'
        },
      };
    },
    initData() {
      const initCause = {
        name: '--',
        accident: 0,
        percentage: '',
        dead: 0,
        injury: 0
      };
      this.causes = [initCause];
      this.characters = [initCause];
      const initVehicleCause = {
        name: '--',
        amount: 0
      };
      initCause.cause = [initVehicleCause];
      this.vehicles = [initCause];
    },
    search() {
      this.initData();
      this.searchCause();
      this.searchCharacter();
      this.searchVehicle();
      this.$refs.chart.chart.reflow();
    },
    searchCause() {
      if (this.searchCondition && this.searchCondition.isBMTA) {
        return;
      }
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/dashboard/accident/cause_by_order`;
      // if (this.searchCondition != null && this.searchCondition.start_date) {
      //   url += `start_date=${this.searchCondition.start_date}&`;
      // }
      // if (this.searchCondition != null && this.searchCondition.end_date) {
      //   url += `end_date=${this.searchCondition.end_date}&`;
      // }

      this.axios
        .get(url, { params: this.searchCondition })
        .then(response => {
          if (response.status == 200 && response.data.data) {
            const { data } = response.data;
            let other_accident = 0;
            let other_dead = 0;
            let other_injury = 0;

            if (scope.summary) {
              other_accident = scope.summary.accident.summary;
              other_dead = scope.summary.dead.summary;
              other_injury = scope.summary.injury.summary;
              for (const cause in data) {
                other_accident -= data[cause].accident;
                other_dead -= data[cause].dead;
                other_injury -= data[cause].injury;
              }
              scope.causes = data.map(item => {
                item.percentage = `${(
                  (item.accident / scope.summary.accident.summary) *
                  100
                ).toFixed(2)}%`;
                return item;
              });
            } else {
              scope.causes = data;
            }
            scope.causes.sort((a, b) => b.accident - a.accident);
            // if (scope.causes.length == 0 || other_accident > 0) {
              scope.causes.push({
                name: 'อื่นๆ',
                accident: other_accident,
                percentage: scope.summary && scope.summary.accident.summary
                  ? `${((other_accident / scope.summary.accident.summary) * 100).toFixed(2)}%`
                  : '',
                dead: other_dead,
                injury: other_injury
              });
            // }
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    searchCharacter() {
      if (this.searchCondition && this.searchCondition.isBMTA) {
        return;
      }
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/dashboard/accident/character_by_order`;

      this.axios
        .get(url, { params: this.searchCondition })
        .then(response => {
          if (response.status == 200 && response.data.data) {
            const { data } = response.data;
            let other_accident = 0;
            let other_dead = 0;
            let other_injury = 0;

            if (scope.summary) {
              other_accident = scope.summary.accident.summary;
              other_dead = scope.summary.dead.summary;
              other_injury = scope.summary.injury.summary;
              for (const cause in data) {
                other_accident -= data[cause].accident;
                other_dead -= data[cause].dead;
                other_injury -= data[cause].injury;
              }
              scope.characters = data.map(item => {
                item.percentage = `${(
                  (item.accident / scope.summary.accident.summary) *
                  100
                ).toFixed(2)}%`;
                return item;
              });
            } else {
              scope.characters = data;
            }
            scope.characters.sort((a, b) => b.accident - a.accident);
            // if (scope.characters.length == 0 || other_accident > 0) {
              scope.characters.push({
                name: 'อื่นๆ',
                accident: other_accident,
                percentage: scope.summary && scope.summary.accident.summary
                  ? `${((other_accident / scope.summary.accident.summary) * 100).toFixed(2)}%`
                  : '',
                dead: other_dead,
                injury: other_injury
              });
            // }
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    searchVehicle() {
      if (this.searchCondition && this.searchCondition.isBMTA) {
        return;
      }
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/dashboard/accident/cause/vehicle_by_order`;
      // if (this.searchCondition != null && this.searchCondition.start_date) {
      //   url += `start_date=${this.searchCondition.start_date}&`;
      // }
      // if (this.searchCondition != null && this.searchCondition.end_date) {
      //   url += `end_date=${this.searchCondition.end_date}&`;
      // }

      this.axios
        .get(url, { params: this.searchCondition })
        .then(response => {
          if (response.status == 200 && response.data.data) {
            const { data } = response.data;
            // const amount = data.reduce((sum, vehicle) => sum + vehicle.accident, 0);
            scope.vehicles = data.map(item => {
              item.cause.sort((a, b) => b.amount - a.amount);
              // item.percentage = (item.accident / amount * 100).toFixed(2) + '%';
              return item;
            });
            scope.vehicles.sort((a, b) => b.accident - a.accident);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getChartColumnOption(dead, injury, format, ymax) {
      return {
        xAxis: {
          type: 'category'
        },
        title: {
          text: ''
        },
        yAxis: {
          max: ymax,
          title: {
            text: ''
          },
          lables: '',
          visible: false
        },
        plotOptions: {
          series: {
            grouping: false,
            pointWidth: 40
          }
        },
        // series: null
        tooltip: {
          enabled: false
        },
        series: [
          {
            type: 'column',
            showInLegend: false,
            data: [
              { name: `${dead} ${format}`, x: 0, y: dead, color: '#BA4438' },
              { name: `${injury} ${format}`, x: 1, y: injury, color: '#F3A055' }
            ]
          },
          {
            type: 'scatter',
            showInLegend: false,
            data: [
              {
                y: dead,
                marker: {
                  symbol: `url(${require('@/assets/icons/death.svg')})`
                }
              },
              {
                y: injury,
                marker: {
                  symbol: `url(${require('@/assets/icons/user-injured-solid.svg')})`
                }
              }
            ]
          }
        ]
      };
    },
    getCauseImage(id) {
      try {
        return require(`@/assets/dashboard_icons/cause_${id}.svg`);
      } catch (e) {
        try {
          return require(`@/assets/dashboard_icons/cause_${id}.png`);
        } catch (e) {
          return require('@/assets/icons/other_reason.svg');
        }
      }
    },
    getCharacterImage(id) {
      try {
        return require(`@/assets/dashboard_icons/character_${id}.svg`);
      } catch (e) {
        try {
          return require(`@/assets/dashboard_icons/character_${id}.png`);
        } catch (e) {
          return require('@/assets/icons/other_appearance.svg');
        }
      }
    },
    getVehicleImage(id) {
      try {
        return require(`@/assets/dashboard_icons/vehicle_${id}.svg`);
      } catch (e) {
        try {
          return require(`@/assets/dashboard_icons/vehicle_${id}.png`);
        } catch (e) {
          return require('@/assets/dashboard_icons/vehicle_7.svg');
        }
      }
    }
  },
  watch: {
    searchCondition() {
      this.search();
    },
    vehicles(value) {
      this.chartPieOptions.colors = this.colors.slice(0, this.vehicles.length);
      const damage = [];
      this.vehicles.forEach((vehicle, i) => {
        damage.push({ name: vehicle.name, y: vehicle.accident });
      });
      this.chartPieOptions.series.data = damage;
      this.chartPieOptions.subtitle.text = 'รวมทั้งหมด ' + (this.vehicles ? 
        this.vehicles.reduce((sum, el) => {
          return sum + el.accident
      }, 0) : 0) + ' คัน';
    },
    summary(val) {
      let other_accident = val.accident.summary;
      let other_dead = val.dead.summary;
      let other_injury = val.injury.summary;

      if (this.causes.length && this.causes[0].accident != 0) {
        for (const cause in this.causes) {
          if (this.causes[cause].id) {
            other_accident -= this.causes[cause].accident;
            other_dead -= this.causes[cause].dead;
            other_injury -= this.causes[cause].injury;
          }
        }

        this.causes = this.causes.map(item => {
          item.percentage = `${((item.accident / val.accident.summary) * 100).toFixed(2)}%`;
          return item;
        });
        if (this.causes.length == 1 || other_accident > 0) {
          this.causes[this.causes.length - 1] = {
            name: 'อื่นๆ',
            accident: other_accident,
            percentage: val.accident.summary ? `${((other_accident / val.accident.summary) * 100).toFixed(2)}%` : '',
            dead: other_dead,
            injury: other_injury
          };
        }
        else {
          this.causes.pop();
        }
      }

      if (this.characters.length && this.characters[0].accident != 0) {
        other_accident = val.accident.summary;
        other_dead = val.dead.summary;
        other_injury = val.injury.summary;
        for (const character in this.characters) {
          if (this.characters[character].id) {
            other_accident -= this.characters[character].accident;
            other_dead -= this.characters[character].dead;
            other_injury -= this.characters[character].injury;
          }
        }

        this.characters = this.characters.map(item => {
          item.percentage = `${((item.accident / val.accident.summary) * 100).toFixed(2)}%`;
          return item;
        });
        if (this.characters.length == 1 || other_accident > 0) {
          this.characters[this.characters.length - 1] = {
            name: 'อื่นๆ',
            accident: other_accident,
            percentage: val.accident.summary ? `${((other_accident / val.accident.summary) * 100).toFixed(2)}%` : '',
            dead: other_dead,
            injury: other_injury
          };
        }
        else {
          this.characters.pop();
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 0;
  background-color: white;
}

.col {
  padding: 0;
}

.v-tab {
  background-color: white;
  color: #ba4438;
}

.v-tab.v-tab--active {
  background-color: #ba4438;
  color: white;
}

.search {
  float: right;
}

.detail {
  background: var(--v-brightgrey-base);
}

.number {
  color: #ba4438;
}

.chart {
  margin-top: 10px;
  margin-bottom: 10px;
}

.sub-menu {
  width: 32px;
  height: 32px;
  margin: auto;
  top: calc(50% - 16px);
}

.rectangle1 {
  min-width: 110px;
  height: 210px;
  border-radius: 3px;
  border: solid 1px #979797;
}

.rectangle2 {
  width: 100%;
  height: 280px;
  border-radius: 3px;
  border: solid 1px #979797;
}

.charts {
  height: 150px;
}

.charts-pie {
  height: 260px;
}

.cause-casualty {
  bottom: 0px;
  position: absolute;
  width: 100%;
}

.title-cause {
  height: 40px;
}

.injury-icon {
  height: 40px;
}

.desktop-tile {
  max-width: 110px;
}

.tablet-tile {
  max-width: 135px;
}
</style>
